import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosPrivate from 'config/axiosPrivate';

function sortByDeadlineDesc(arr) {
  return arr.sort((a, b) => new Date(b.deadline) - new Date(a.deadline));
}
export const fetchAllOrders = createAsyncThunk(
  'WriterOrderList/fetchAllOrders',
  async (input, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const role = state?.userSession?.user?.role;
      const emptyData = {
        VALID: [],
        DELAYED: [],
        INPROGRESS: [],
        NONATTRIBUTED: [],
        SMART_WITH_REVIEW: [],
        SMART: [],
      };
      if (role !== 'WRITER') {
        return thunkAPI.fulfillWithValue(emptyData);
      }
      const response = await axiosPrivate.get('/commands/commandsByStatus');
      if (response.status === 200) {
        let data = response.data;
        Object.keys(data).forEach((key) => {
          if (Array.isArray(data[key])) {
            data[key] = sortByDeadlineDesc(data[key]);
          }
        });
        return data;
      }
      return thunkAPI.rejectWithValue(response.status);
    } catch (e) {
      if (e?.response?.status === 403) {
        return thunkAPI.fulfillWithValue({
          VALID: [],
          DELAYED: [],
          INPROGRESS: [],
          NONATTRIBUTED: [],
          SMART_WITH_REVIEW: [],
          SMART: [],
        });
      }
      return thunkAPI.rejectWithValue(e?.response?.data || e.message);
    }
  }
);
